<div class="title mb-4">
  <h2>MYVIP FEATURES</h2>
</div>

<div class="row">
  <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
    <video autoplay id="use_case_vid">
      <source
        src="../../../assets/images/new/use_case_video.mp4"
        type="video/mp4"
      />
      Your browser does not support the video tag.
    </video>
  </div>
</div>
